'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _DTBButton = require('pricing-pages-unified-ui/components/public-only/DTBButton');

var _DTBButton2 = _interopRequireDefault(_DTBButton);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DTBButtonContainer = function DTBButtonContainer(props) {
  return _react2.default.createElement(_DTBButton2.default, props);
};

_DTBButton2.default.propTypes = {
  dtbSource: _react.PropTypes.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DTBButtonContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/public-only/DTBButtonContainer.js
// module id = 713
// module chunks = 3 4